var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('top-banner'),_c('impersonation'),_c('loading-indicator'),_c('main-header'),_c('snackbars'),_c('main-sidebar'),_c('modals-container'),_c('access-control',[_c('router-view')],1),_c('main-footer'),_c('system-banner'),_c('terms-modal'),_c('sticky-banner'),_c('mobile-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }